import { useEffect, useRef, useState } from "react";
import { Ifilter } from "../../../Interfaces/filter";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { GrupoIncidenteService } from "../../../services/hazard/grupoIncidente";

export const UseComboIncidente=(isOpen: boolean)=>{
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboIncidente, setDataComboIncidente] = useState<IComboBoxOption[]>([]);
    const comboBoxRefIncidente = useRef<IComboBox>(null);
    const onClickComboRazon = () => comboBoxRefIncidente.current?.focus(true);
    const onChange = (value:any) => {
        setFilter({ ...filter, search: value });
    }
    const _onkeyUpSearchRazon = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefIncidente.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        GrupoIncidenteService.ComboGrupoIncidente(filter, newController).then((res) => {
            if (res.status === 200) {
                setDataComboIncidente(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    useEffect(() => {
        if (filter.search != "") {
            listarCombo()
        }
    }, [filter.search])

    return {
        dataComboIncidente,
        onClickComboRazon,
        _onkeyUpSearchRazon,
        comboBoxRefIncidente,
        onChange,
        filter,
        setFilter
    };
}